__turbopack_context__.v({
  "offCanvasDialog": "OffCanvasDialog-module-scss-module__wU_6BW__offCanvasDialog",
  "offCanvasDialog_closed": "OffCanvasDialog-module-scss-module__wU_6BW__offCanvasDialog_closed",
  "offCanvasDialog_closing": "OffCanvasDialog-module-scss-module__wU_6BW__offCanvasDialog_closing",
  "offCanvasDialog_opening": "OffCanvasDialog-module-scss-module__wU_6BW__offCanvasDialog_opening",
  "slideInLeft": "OffCanvasDialog-module-scss-module__wU_6BW__slideInLeft",
  "slideOutLeft": "OffCanvasDialog-module-scss-module__wU_6BW__slideOutLeft",
});
